var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (! _vm.status)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.status === null ? 'loading' : 'error'),expression:"status === null ? 'loading' : 'error'"}]}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77216d2f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Status.vue
// module id = 111
// module chunks = 0